export default __webpack_public_path__ + "static/media/five.b4d95d7a.png";